import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@awaze/design-system.components.text';
import { StyledHeading } from './results-count.styles';
/**
 * A component for displaying the number of matching search results
 */
export const ResultsCount = ({ count, labels = {
    textSingle: 'property',
    textMultiple: 'properties',
}, }) => {
    const { textSingle, textMultiple } = labels;
    return (_jsxs(StyledHeading, { children: [_jsx(Text, { as: "span", type: "bold", sizes: [200, 400, 400], children: count }), "\u00A0", _jsx(Text, { as: "span", sizes: [200, 400, 400], children: count === 1 ? textSingle : textMultiple })] }));
};
//# sourceMappingURL=results-count.js.map